import { DashboardHeader } from '@/components/dashboard/dashboard-header'
import { DashboardShell } from '@/components/dashboard/dashboard-shell'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { COLORS } from '@repo/shared_utils'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowRight, Clock, Users } from 'lucide-react'

export const Route = createFileRoute('/dashboard/supervisor/')({
  component: RouteComponent,
})

function RouteComponent() {
  const managementOptions = [
    {
      title: 'Manage Timesheets',
      description: 'Review and oversee employee timesheets and attendance records',
      path: '/dashboard/supervisor/timesheets',
      icon: <Clock className="h-8 w-8" />,
      color: COLORS[3],
    },
    {
      title: 'Manage Employees',
      description: 'View and manage employee information for your team',
      path: '/dashboard/supervisor/employees',
      icon: <Users className="h-8 w-8" />,
      color: COLORS[4],
    },
  ]

  return (
    <div className="min-h-screen">
      <div className="relative max-w-6xl mx-auto p-4">
        <DashboardShell>
          <DashboardHeader
            heading="Supervisor Dashboard"
            text="Oversee your team's timesheets and employee activity"
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
            {managementOptions.map((option) => (
              <Card
                key={option.path}
                className="group relative overflow-hidden bg-white/80 dark:bg-gray-900 backdrop-blur-lg border shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                <CardHeader className="pb-4">
                  <div className="flex items-center justify-between">
                    <div
                      className="flex h-12 w-12 items-center justify-center rounded-xl transition-all duration-300 group-hover:scale-110"
                      style={{ backgroundColor: `${option.color}15` }}
                    >
                      <div style={{ color: option.color }}>{option.icon}</div>
                    </div>
                    <ArrowRight className="h-5 w-5 text-muted-foreground transition-transform duration-300 group-hover:translate-x-1" />
                  </div>
                  <CardTitle className="text-xl font-semibold" style={{ color: option.color }}>
                    {option.title}
                  </CardTitle>
                  <CardDescription className="text-base leading-relaxed">
                    {option.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="mt-auto">
                  <Link to={option.path} className="w-full">
                    <Button
                      size="lg"
                      className="w-full h-12 text-base font-medium rounded-xl transition-all duration-300 hover:scale-105 shadow-md hover:shadow-lg"
                      style={{ backgroundColor: option.color }}
                    >
                      <span className="relative flex items-center gap-2">
                        Access {option.title}
                        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </span>
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </DashboardShell>
      </div>
    </div>
  )
}
